import { __assign, __rest } from "tslib";
import React from 'react';
import { components } from 'react-select';
import { ChevronDown24, ChevronUp24 } from '@carbon/icons-react';
import { twMerge } from 'tailwind-merge';
export var CustomDropdownIndicator = function (_a) {
    var props = __rest(_a, []);
    var newProps = __assign(__assign({}, props), { className: props.className });
    return (React.createElement(components.DropdownIndicator, __assign({}, newProps), props.selectProps.menuIsOpen ? (React.createElement(ChevronUp24, { className: twMerge('text-mirage cursor-pointer', props.isDisabled && 'text-alto pointer-events-none') })) : (React.createElement(ChevronDown24, { className: twMerge('text-mirage cursor-pointer', props.isDisabled && 'text-alto pointer-events-none') }))));
};
